module.exports = __webpack_public_path__ + "static/4-34ebcd5541fb8f65036839de0cc0cb73.png";